import React from 'react';
import { FieldPathByValue, UseFormReturn } from 'react-hook-form';
import { CardBody, CardHeader, CardTitle } from '@progress/kendo-react-layout';
import SubjectProfileDetailsConfigurationCheckboxList from './checkbox-list';
import Card from '@components-clean/core/card';
import { TextBoxController } from '@components-clean/core/text-box';
import { useTranslation } from '@hooks/index';
import { SubjectProfileDetailsConfigurationFormValues } from './types';

type CheckboxKey = FieldPathByValue<
    Exclude<SubjectProfileDetailsConfigurationFormValues['subjectStatus'], null>,
    boolean | null
>;

const mainCheckboxKeys: CheckboxKey[] = [
    'status',
    'screening',
    'screenFail',
    'screenFailReason',
    'enrolled',
    'randomized',
    'fUStart',
    'fUCompleted',
    'studyDisc',
    'studyDiscReason',
    'lastVisitNameAndDate',
];

type Props = {
    control: UseFormReturn<SubjectProfileDetailsConfigurationFormValues>['control'];
    disabled: boolean;
};

const SubjectStatusCard = ({ control, disabled }: Props) => {
    const { t } = useTranslation('admin', {
        keyPrefix: 'subjectConfig.subjectProfileDetailsConfig.subjectStatus',
    });

    return (
        <Card padding="none" data-testid="subject-profile-details-configuration-subject-status">
            <CardHeader>
                <CardTitle>{t('title')}</CardTitle>
            </CardHeader>

            <CardBody>
                <div>
                    <TextBoxController
                        control={control}
                        name="subjectStatus.label"
                        required
                        maxLength={50}
                        label={`${t('field.label')}*`}
                        data-testid="checkbox-subjectStatus-label"
                        disabled={disabled}
                    />
                </div>

                <SubjectProfileDetailsConfigurationCheckboxList
                    control={control}
                    disabled={disabled}
                    checkboxKeys={mainCheckboxKeys.map((key) => ({
                        key: `subjectStatus.${key}`,
                        label: t(`field.${key}`),
                    }))}
                />
            </CardBody>
        </Card>
    );
};

export default SubjectStatusCard;
